module.exports = __webpack_public_path__ + "static/media/PlayWorkout_Sketch.5193761b.png";